

















import Vue from 'vue';
import { firebase } from 'mostra';
import 'ress';

export default Vue.extend({
  name: 'app',
  // data(): DataType {
  //   return {
  //     exhibitor: null,
  //   };
  // },
  // mixins: [VersionsMixin],
  // async created() {
  //   this.exhibitor = await exhibitor.load(this.$auth.uid);
  //   console.log(this.exhibitor);
  // },
  computed: {
    isProduction() {
      return process.env.NODE_ENV === 'production';
    },
  },
  methods: {
    async onClick() {
      try {
        await firebase.auth().signOut();
      } catch (error: any) {
        this.$fatal(error);
      }
    },
  },
});
